export const appInfo = {
  title: 'WerkbonIQ',
};
